import angular from 'angular';
import { ConfirmDeleteModal } from '~/utils/modals';
import SearchFactory from '~/components/search-bar/search.factory';
import BookmarkModel from './bookmark.model';
import templateModalDroit from '../droit/modal/modal-droit.html';
import ModalDroitController from '../droit/modal/modal-droit.controller';

/* globals Knitiv */

export default class BookmarkController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {BookmarkModel} Bookmark
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {SearchFactory} Search
	 * @param {any} $injector
	 * @param {import('angular').IQService} $q
	 */
	constructor(
		$scope,
		$rootScope,
		$timeout,
		$translate,
		$location,
		$uibModal,
		Bookmark,
		NodeService,
		Notification,
		Search,
		$injector,
		$q,
	) {
		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.$location = $location;
		/** @type {BookmarkModel} */
		this.Bookmark = Bookmark;
		this.NodeService = NodeService;
		this.Notification = Notification;
		/** @type {SearchFactory} */
		this.Search = Search;
		this.$injector = $injector;
		/** @type {import('angular').IQService} */
		this.$q = $q;

		/** @type {any[]} */
		this.bookmarks = [];

		/** @type {boolean} */
		this.loading = false;

		/** @type {boolean} */
		this.isOpen = false;

		this.widgetId = '';
	}

	/**
	 * @param {any} bookmark
	 */
	async delete(bookmark) {
		const modal = new ConfirmDeleteModal(this.$injector);
		const answer = await modal.open(bookmark.name);

		if (answer) {
			await this.Bookmark.delete(bookmark.kid);
			await this.list();
		}
	}

	/**
	 * @param {any} bookmark
	 * @param {KeyboardEvent} event
	 */
	edit(bookmark, event) {
		bookmark.edit = true;
		this.$timeout(
			// @ts-ignore
			() => angular.element(event.target).closest('.list-group-item').find('input.form-control').trigger('focus'),
		);
	}

	/**
	 * @param {any} bookmark
	 */
	async editDroits(bookmark) {
		bookmark.node = await this.NodeService.load(bookmark.kid);
		bookmark.node = await this.$uibModal.open({
			ariaLabelledBy:  'modal-droit-title',
			ariaDescribedBy: 'modal-droit-body',
			template:        templateModalDroit,
			controller:      ModalDroitController,
			controllerAs:    '$ctrl',
			resolve:         {
				node() {
					return bookmark.node;
				},
				edit: true,
			},
		}).result;
		await this.NodeService.update(bookmark.node);
		bookmark.edit = false;
		this.Notification.info({
			title:   this.$translate.instant('common.info'),
			message: this.$translate.instant('search.bookmark-updated'),
		});
	}

	async list() {
		this.loading = true;
		this.bookmarks.length = 0;

		const result = await this.Bookmark.list();
		for (const row of result.result.rows) {
			const { name } = row[0][0];
			const { kid } = row[0][0];
			const favoriteAttributeDataRaw = row[1][0].name;

			/** @type {Bookmark.SavedBookmark} */
			try {
				const favoriteAttributeData = JSON.parse(String(favoriteAttributeDataRaw) || '{}');

				this.bookmarks.push({
					name,
					oldName: name,
					kid,
					loading: false,
					edit:    false,
					node:    null,
					type:    favoriteAttributeData.type,
				});
			}
			catch (error) {
				console.error(error);
			}
		}

		this.$timeout(() => {
			this.loading = false;
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
		});
	}

	/**
	 * @param {boolean} state
	 */
	onToggle(state) {
		this.state = state;
		let count = 5;
		// eslint-disable-next-line angular/interval-service
		const interval = setInterval(() => {
			if (count <= 0) {
				clearInterval(interval);
			}
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
			count -= 1;
		}, 100);
	}

	/**
	 * @param {any} b
	 */
	async open(b) {
		if (!b.edit) {
			if (!b.node) {
				b.node = await this.NodeService.load(b.kid);
			}
			const { type, data } = b.node.getAttribute('FAVORI').value;

			if (type === 'node') {
				/** @type {Bookmark.SavedDataNode} */
				// @ts-ignore
				const myData = data;
				this.$timeout(() => {
					this.$location.path(`/form/${myData.kid}`);
				});
			}
			else if (type === 'search') {
				await this.Search.setFromKid(data.type, data.filters);
				this.$timeout(() => {
					this.$rootScope.$emit('Search.onLaunchSearch');
				});
			}
			else {
				throw new Error('Invalid bookmark type');
			}
		}
	}

	refreshSize() {
		let count = 5;
		// eslint-disable-next-line angular/interval-service
		const interval = setInterval(() => {
			if (count <= 0) {
				clearInterval(interval);
			}
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
			count -= 1;
		}, 100);
	}

	/**
	 * @param {any} bookmark
	 * @param {KeyboardEvent} event
	 */
	async rename(bookmark, event) {
		if (event.type === 'click' || (event.type === 'keyup' && event.key === 'Enter')) {
			if (bookmark.name === bookmark.oldName) {
				bookmark.edit = false;
			}
			else {
				bookmark.loading = true;
				try {
					await this.Bookmark.rename(bookmark, bookmark.name);
					bookmark.loading = false;
					bookmark.edit = false;
				}
				catch {
					bookmark.loading = false;
				}
			}
		}
		if (!bookmark.loading && ((event.type === 'keyup' && event.key === 'Escape') || event.type === 'blur')) {
			bookmark.name = bookmark.oldName;
			bookmark.edit = false;
		}
	}

	/**
	 * @param {Event} event
	 */
	toggle(event) {
		event.stopPropagation();
		this.isOpen = !this.isOpen;
	}

	$onInit() {
		(async () => this.list())();
	}
}
